import { Button, Divider, Flex, Grid } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { DashDateTime as DateTime } from "src/components/shared/DateTime";
import { useIsOnline } from "src/hooks";
import {
  ButtonsContainer,
  HomeHeader,
  HomeHeaderWrapper,
} from "src/pages/Home/Home.styled";
import { type ICustomDashboard } from "src/pages/Home/Home.types";

import { CardWrapper, DashboardContainer } from "./CustomDashboard.styled";
import DashboardLogbookCard from "./DashboardLogbookCard";
import DashboardWidget from "./DashboardWidget";

interface Props {
  customDashboard: ICustomDashboard;
  yachtid: string;
}

const FULL_WIDTH_WIDGETS = ["events", "watchkeepers"];
function getWidgetCols(widgetID: string) {
  const full = FULL_WIDTH_WIDGETS.includes(widgetID);
  return {
    xs: 12,
    sm: 12,
    md: 9,
    lg: full ? 12 : 6,
    xl: full ? 12 : 6,
  };
}

export default function CustomDashboard({ customDashboard, yachtid }: Props) {
  const { cols, content } = customDashboard;
  const navigate = useNavigate();
  const isOnline = useIsOnline();

  const sorted = Object.entries(content).sort(
    ([a], [b]) => parseInt(a) - parseInt(b),
  );
  const logbooks = sorted.filter(([, item]) => item.type === "logbook");
  const widgets = sorted.filter(([, item]) => item.type === "widget");

  return (
    <>
      <HomeHeaderWrapper>
        <HomeHeader>
          <Flex
            align="center"
            justify="space-between"
            style={{ width: "100%" }}>
            <div style={{ flex: 1 }} />

            <DateTime />

            <ButtonsContainer
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "flex-end",
                marginRight: "22px",
                gap: 8,
              }}>
              <Button
                size="sm"
                variant="outline"
                onClick={() => navigate("/summary")}>
                Summary
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={() => navigate("/reports")}>
                Reports
              </Button>
              <Button
                size="sm"
                variant="outline"
                disabled={!isOnline}
                onClick={() => navigate("/organize-logbooks")}>
                Organize
              </Button>
            </ButtonsContainer>
          </Flex>
        </HomeHeader>
      </HomeHeaderWrapper>
      <Divider mt={10} />

      <DashboardContainer>
        <Grid align="stretch" gutter={20} justify="center">
          {logbooks.map(([idx, item]) => (
            <Grid.Col
              key={idx}
              xs={12}
              sm={12}
              md={6}
              lg={4}
              xl={Math.floor(12 / cols)}
              style={{
                display: "flex",
                maxWidth: "360px",
                maxHeight: "200px",
              }}>
              <CardWrapper>
                <DashboardLogbookCard
                  lbid={item.lbid}
                  data={item.data as any}
                />
              </CardWrapper>
            </Grid.Col>
          ))}
        </Grid>

        <Grid align="stretch" gutter={20} justify="center" mt="md">
          {widgets.map(([idx, item]) => {
            const span = getWidgetCols(item.widgetID);
            return (
              <Grid.Col
                key={idx}
                xs={span.xs}
                sm={span.sm}
                md={span.md}
                lg={span.lg}
                xl={span.xl}
                style={{ display: "flex", maxHeight: "520px" }}>
                <CardWrapper>
                  <DashboardWidget
                    widgetID={item.widgetID}
                    data={item.data as any}
                    yachtid={yachtid}
                    lbid={(item.data as any).lbid || ""}
                  />
                </CardWrapper>
              </Grid.Col>
            );
          })}
        </Grid>
      </DashboardContainer>
    </>
  );
}
